module.exports = __webpack_public_path__ + "static/image2-a6f57ad45ecfc0c76707be5a18525078.jpg";